module.exports = __webpack_public_path__ + "img/slys2.d80ca481.png";